<template>
  <div
    class="button"
    :class="{expanded: active}"
    v-on="$listeners"
  >
    <span class="triangle">▸</span>
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'DisclosureTriangle',
  props: {
    active: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.button {
  display: inline-block;
  cursor: pointer;
  user-select: none;
}
.triangle {
  display: inline-block;
  // The glyph is an icon, not type: it should be the same size wherever it
  // sits, so it ignores the weight and tracking of the heading around it.
  // (Scoped to the glyph, so slot text still inherits.)
  font-weight: normal;
  letter-spacing: normal;
  transform-origin: 50% 50%;
  transform: rotate(0deg);
  .expanded & {
    transform: rotate(90deg);
  }
  .expanded.rotate-180 & {
    transform: rotate(180deg);
  }
}
</style>
